import {Box, Card, Divider, Typography} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {TrackEventUBA} from '@jobseeker/common-core/utils';
import {useInView} from '@jobseeker/lotus/hooks';
import {JDQueryParams} from '../type';

type TrendSectionProps = {
  insights?: {
    experience?: {
      value?: string;
      label?: string;
    };
    hires?: {
      value?: string;
      label?: string;
    };
    jobseekersReached?: {
      value?: string;
      label?: string;
    };
  };
  templateInfo?: {
    templateNo?: string;
    origin?: string;
  };
  jobInfo?: any;
  jdQueryParams?: JDQueryParams;
};
const CompanyInsights: React.FC<TrendSectionProps> = ({
  insights,
  templateInfo,
  jobInfo,
  jdQueryParams,
}) => {
  const {ref, isInView} = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });
  const [companyAwardsTracked, setCompanyAwardsTracked] = useState(false);

  useEffect(() => {
    if (isInView && !companyAwardsTracked) {
      TrackEventUBA('sectionView', 'view', {
        ref: jdQueryParams?.ref || '',
        pageName: 'JD',
        jobID: jobInfo?.id,
        page: 'JD',
        templateID: templateInfo?.templateNo,
        isBranded: 'Yes',
        companyID: jobInfo?.companyData?.companyId,
        centralCompanyID: jobInfo?.recruiter?.centralizedCompanyId,
        companyName: jobInfo?.companyData?.companyName,
        section: 'Insights',
        sessionUsername: sessionStorage.getItem('userId') || '',
      });
      setCompanyAwardsTracked(true);
    }
  }, [isInView, companyAwardsTracked]);
  const items = Object.values(insights || {});
  return (
    <Box p={2} pl={1.5} pb={2.5} ref={ref}>
      <Card
        variant="outlined"
        sx={{
          border: 'none',
          backgroundColor: '#F9FAFB',
          display: 'flex',
          alignItems: 'start', // full height dividers
        }}
      >
        {items.map((item, index) => (
          <React.Fragment key={index}>
            {/* STAT SECTION */}
            <Box
              sx={{
                flex: '1 1 0', // 🔑 equal width
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <Typography
                fontSize={20}
                fontWeight={600}
                sx={{
                  wordBreak: 'break-word',
                  overflowWrap: 'anywhere',
                  lineHeight: '24px',
                  pb: 0.5,
                }}
              >
                {item.value}
              </Typography>

              <Typography
                fontSize={10}
                color="#7E7E7E"
                fontWeight={500}
                lineHeight={1.3}
                sx={{
                  wordBreak: 'break-word',
                  overflowWrap: 'anywhere',
                }}
              >
                {item.label}
              </Typography>
            </Box>

            {/* DIVIDER */}
            {index !== items.length - 1 && (
              <Divider
                orientation="vertical"
                flexItem
                sx={{
                  mx: 1,
                  my: '0px !important',
                  borderColor: '#EFEDFF',
                }}
              />
            )}
          </React.Fragment>
        ))}
      </Card>
    </Box>
  );
};

export default CompanyInsights;
